
<div mat-dialog-title>Category Overwrite<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <div class ="block">The security import will overwrite the existing asset category assignments shown below.</div>
  <div>
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'240px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      [rowData] = 'data.oerwriteData'
    (gridReady) = "onGridReady($event)"></irb-inventory-grid>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  @if (!isFinish) {
    <button id="continueButton" (click)="completeImport()" class="btn-medium-primary">Continue</button>
  }
  @if (isFinish) {
    <button id="finishButton" (click)="completeImport()" class="btn-medium-primary">Finish</button>
  }
</mat-dialog-actions>
